import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { CLOSE_BANKING_MODAL } from './LinkOpenBankingModal.actions';
import { TrueLayer } from './trueLayer';
import { SHOW_UPLOAD_DOCUMENTS_MODAL } from '../uploadDocumentsModal/UploadDocumentsModal.actions';
import { BANK_STATMENT_DOC_TYPE } from '../uploadDocumentsModal/UploadDocumentsModalHelper';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    closeModal: () => {
        dispatch({
            type: CLOSE_BANKING_MODAL
        });
    },
    uploadBankStatementDocument: () => {
        dispatch({
            type: SHOW_UPLOAD_DOCUMENTS_MODAL,
            documentType: BANK_STATMENT_DOC_TYPE
        });
    }
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const LinkOpenBankingModal = (props: PropsFromRedux) => {
    const { closeModal, uploadBankStatementDocument } = props;

    return (
        <TrueLayer
            handleClose={closeModal}
            handleUploadBankStatements={uploadBankStatementDocument}
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(LinkOpenBankingModal);
